import { aboutContent } from '@/mocks/home';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-sm font-medium text-secondary-600 mb-2">品牌故事</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{aboutContent.title}</h2>
          </div>

          <div className="space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="grid grid-cols-3 gap-4 md:gap-8 mt-10 md:mt-12">
            {aboutContent.stats.map((stat, i) => (
              <div key={i} className="text-center p-4 md:p-6 bg-background-50 rounded-xl border border-background-200/60">
                <div className={`font-heading text-2xl md:text-3xl font-bold ${
                  i === 0 ? 'text-primary-600' : i === 1 ? 'text-accent-600' : 'text-secondary-600'
                }`}>
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}